export default "__VITE_ASSET__2180272d__"